import Vue from 'vue'
import Vuex from 'vuex'
import { LoggedInUser } from './LoggedInUser'
import { PageURLRally } from './PageURLRally'
import { PageURLRallyRound } from './PageURLRallyRound'
import { PageURLTeam } from './PageURLTeam'
import { Chat } from './Chat'
import { Rally } from './Rally'
import { SearchFilterOptions } from './SearchFilterOptions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    LoggedInUser,
    PageURLRally,
    PageURLRallyRound,
    PageURLTeam,
    Chat,
    Rally,
    SearchFilterOptions
  }
})
